import numeral from "numeral";

export function formatNumber(value: any, currency = "", format = "0,0") {
  return `${currency}${numeral(value).format(format)}`;
}
export const formatMoney = (value, currency = "") => {
  return `${currency}${numeral(value).format("0,0.00")}`;
};
